import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { GREEN, RED } from './reportingHelpers';

// Cellule combinée : lavés (vert) / impossibles (rouge, badge si élevé) / prévu (noir).
export default function LavagesCell({ laves, imp, prevu, high }) {
  const sep = <span style={{ color: '#B0BEC5' }}> / </span>;
  return (
    <Tooltip title="Lavés / impossibles / prévu" arrow>
      <span style={{ whiteSpace: 'nowrap' }}>
        <b style={{ color: GREEN }}>{laves}</b>
        {sep}
        {high ? (
          <Box component="span" sx={{ backgroundColor: RED, color: '#fff', px: 0.7, py: 0.1, borderRadius: 1, fontWeight: 'bold' }}>
            {imp}
          </Box>
        ) : (
          <b style={{ color: RED }}>{imp}</b>
        )}
        {sep}
        <span style={{ color: '#1a1a1a' }}>{prevu != null ? prevu : '—'}</span>
      </span>
    </Tooltip>
  );
}
